import { FC } from "react";
import { Box, Modal, Stack, Typography, Button } from "@mui/material";
import BasketSvg from "@/assets/svg/BasketSvg";
import { styles } from "./stylesDeactivateYourAccountModal";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeactivateYourAccountModal: FC<Props> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      disableAutoFocus
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
    >
      <Box sx={styles.paper}>
        <Stack sx={styles.inner}>
          <Stack sx={styles.iconTextBlock}>
            <Box sx={styles.iconWrap}>
              <BasketSvg variant="large" width={18} height={18} />
            </Box>
            <Typography sx={styles.title}>
              Are you sure you want to deactivate your account?
            </Typography>
          </Stack>

          <Stack direction="row" sx={styles.buttonsRow}>
            <Button sx={styles.cancelBtn} onClick={onClose}>
              Cancel
            </Button>
            <Button sx={styles.deactivateBtn} onClick={onConfirm}>
              Deactivate
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DeactivateYourAccountModal;
